import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {UrlService} from "app/core/services/url.service";
import {ErrorHandlingService} from "app/core/services/error.handling.service";
import {PermissionsService} from "app/core/services/permissions.service";
import {BehaviorSubject, Observable, tap} from "rxjs";
import {ResConsumptionData} from "./res.consumption.types";
import {UrlEnum} from "app/core/types/url-enum";
import {ObservableErrHandler} from "app/core/types/err.handling.types";

@Injectable({providedIn: 'root'})
export class ResConsumptionService
{
    private readonly _urlService: UrlService = inject(UrlService);
    private readonly _errHandlService: ErrorHandlingService = inject(ErrorHandlingService);
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _permissionSrv: PermissionsService = inject(PermissionsService);
    private readonly _data: BehaviorSubject<ResConsumptionData> = new BehaviorSubject(null);
    private readonly _busy: BehaviorSubject<boolean> = new BehaviorSubject(false);

    get busy$() {
        return this._busy.asObservable();
    }

    /**
     * Constructor
     */
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for data
     */
    get data$(): Observable<ResConsumptionData> {
        return this._data.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get data
     */
    getDataFromBE(): void
    {
        if(!this._permissionSrv.isTenantAdmin() && !this._permissionSrv.isTenantOwner()){
            return;
        }

        if(this._data.value){
            //do not get new data if data exists
            return;
        }

        this._busy.next(true);
        const obs = this._httpClient.get<ResConsumptionData>(
            this._urlService.getUrl(UrlEnum.private_get_clinic_consumption));

        const errWrapper: ObservableErrHandler = {
            observable: obs,
            err_title: "Error",
            err_message: "There was a problem getting consumption data for clinic."
        };

        this._errHandlService.watchThis(errWrapper);
        errWrapper.observable = errWrapper.observable.pipe(tap({
                next: value => {
                    // anounce new data
                    this._data.next(value);
                },
                error: err => {
                    this._busy.next(false);
                },
                complete: () => {
                    this._busy.next(false);
                }
            }
        ));

        errWrapper.observable.subscribe();
    }
}
